import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { modalCloseButtonStyle } from "../../reusable/styles";
import Style from "./confirmationModal.module.css";
import Button from "../button/button";

const ConfirmationModal = (props) => {
  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={props.onClose}
      center
      styles={{
        modal: {
          width: props.width ? props.width : "539px",
          borderRadius: "4px",
        },
        closeButton: modalCloseButtonStyle,
        closeIcon: { fill: "red", marginTop: 5 },
      }}
    >
      <div className={Style.headerLine} />
      <div className={Style.modalTitle}>{props.title}</div>

      <div className={Style.bodyWrapper}>
        <div className={Style.body}>
          <div className={Style.message}>{props.errorMessage}</div>
        </div>
      </div>
      <div className={Style.buttonPosition}>
        <Button
          buttonStyle={{ width: "130px", backgroundColor: "red" }}
          style={{ margin: "10px", marginLeft: "0px" }}
          text={props.leftButtonText}
          onClick={props.leftButtonAction}
        />
        <Button
          buttonStyle={{ width: "130px" }}
          style={{ margin: "10px", marginRight: "0px" }}
          text={props.rightButtonText}
          onClick={props.rightButtonAction}
        />
      </div>
    </Modal>
  );
};
export default ConfirmationModal;
